import { useEffect } from 'react';

// We only want to initialize nosleep once
// https://linear.app/air/issue/ENG-131/update-wakelock-hook-to-not-use-any
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let NS: any;
// https://linear.app/air/issue/ENG-131/update-wakelock-hook-to-not-use-any
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let noSleep: any;

export const useWakelock = (shouldStayAwake: boolean) => {
  // but wakelock may be dynamically enabled or disabled based upon the dynamic `shouldStayAwake` variable
  useEffect(() => {
    NS = !NS ? require('nosleep.js') : NS;
    noSleep = !noSleep ? new NS() : noSleep;
    const isWakeLockActive = !!noSleep._wakeLock;

    if (!isWakeLockActive && shouldStayAwake) {
      noSleep.enable();
    }

    if (isWakeLockActive && !shouldStayAwake) {
      noSleep.disable();
    }

    return () => {
      noSleep.disable();
    };
  }, [shouldStayAwake]);
};
